// TV2DKHEADER
(() => {
  const header = document.querySelector('.tc_header');
  const isAuthenticated = window?.dataLayer?.ssrAuthenticated;
  const badgeEnabled = false; // toggle red badge on loginbutton

  // HEADER VISIBILITY
  const headerScrollAnimation = () => {
    const headerHeight = header.offsetHeight;
    const initAnimationAfter = 500;
    const scrollTriggerDelta = 100;

    let scrolling;
    let ticking = false;
    let lastScroll = 0;

    const headerAnimate = () => {
      // scrolling down
      if (scrolling - scrollTriggerDelta > lastScroll) {
        if (headerHeight < scrolling) {
          header.classList.remove('tc_header--sticky-show');
        }

        if (headerHeight * 2 < scrolling) {
          header.classList.add('tc_header--sticky');
        }

        if (initAnimationAfter < scrolling) {
          // we need to make sure tc_header--sticky and the animate class
          // is not set in the same tick
          // if they are both added in the same tick, the animation transition will flash
          setTimeout(() => {
            header.classList.add('tc_header--sticky-animate');
          }, 0);
        }

        lastScroll = scrolling;

        // scrolling up
      } else if (
        scrolling + scrollTriggerDelta < lastScroll ||
        scrolling < headerHeight
      ) {
        if (!header.classList.contains('tc_header--sticky-animate')) {
          header.classList.remove('tc_header--sticky');
        }

        header.classList.add('tc_header--sticky-show');

        lastScroll = scrolling;
      }

      if (
        scrolling === 0 ||
        (header.getAttribute('data-variant') === 'feature' &&
          scrolling < headerHeight)
      ) {
        header.classList.remove('tc_header--sticky');
        header.classList.remove('tc_header--sticky-animate');
        header.classList.remove('tc_header--sticky-show');
      }

      ticking = false;
    };

    const headerRequestTick = () => {
      if (!ticking) {
        ticking = true;
        requestAnimationFrame(headerAnimate);
      }
    };

    const headerOnScroll = () => {
      scrolling = window.scrollY;
      headerRequestTick();
    };

    // init watching for scroll
    window.addEventListener('scroll', headerOnScroll, false);
  };

  // DIALOGS (menu & login)
  const dialogs = () => {

    const root = document.documentElement;
    const scrollbarWidth = window.innerWidth - root.clientWidth;
    root.style.setProperty('--scrollbar-width', `${scrollbarWidth}px`);

    // Dialog opens
    const dialogOpen = (targetId) => {
      // if loginmenu dialog
      if (targetId === 'loginmenu') {
        handleBadge('open');
      }
    };

    // init loginmenu popover toggle
    const loginmenu = document.getElementById('loginmenu');
    if (loginmenu) {
      loginmenu.addEventListener('toggle', (e) => {
        if (e.newState === 'open') {
          themeSelector();
          regionSelector();
        }
      });
    }

    // Close a dialog
    const dialogClose = (targetId) => {
      // if loginmenu dialog
      if (badgeEnabled && targetId === 'loginmenu') {
        handleBadge('close');
      }
    };

    // BUTTON CLICK EVENTHANDLER
    const buttonClickHandler = (e) => {
      const button = e.target.closest('.ds_button');

      if (button) {
        const targetId = button.getAttribute('popovertarget');
        const targetAction = button.getAttribute('popovertargetaction');

        // a dialog action button
        if (targetId && targetAction) {
          targetAction === 'show' && dialogOpen(targetId);
          targetAction === 'hide' && dialogClose(targetId);
        }

        // login button
        if (button.classList.contains('tc_header__dialog__main__btns__login')) {
          e.preventDefault();
          window.tv2.auth0.login('login', window.location.href);
        }

        // signup button
        if (
          button.classList.contains('tc_header__dialog__main__btns__signup')
        ) {
          e.preventDefault();
          window.tv2.auth0.login('signup', window.location.href);
        }

        // logout button
        if (
          button.classList.contains('tc_header__dialog__main__btns__logout')
        ) {
          e.preventDefault();
          window.tv2.auth0.logout();
        }
      }
    };

    // THEME
    const themeWrapper = header.querySelector(
      '.tc_header__dialog__main__nav__item--theme',
    );
    const themeTag = document.querySelector('meta[name="color-scheme"]');
    const themeTagValue = themeTag && themeTag.getAttribute('content');
    const themeTagDefaultValue =
      themeTag && themeTag.getAttribute('data-default');

    if (isAuthenticated) {
      const themeCookieValue = window.tv2.utils.getCookie('tv2Theme');

      if (themeCookieValue) {
        // mark radio option selected based on theme set in cookie
        const themeSelected = themeWrapper.querySelector(
          `input[value="${themeCookieValue}"]`,
        );
        if (themeSelected) {
          themeSelected.checked = true;
        }

        // keep cookie and metatag in sync
        if (themeTagValue !== themeCookieValue) {
          themeTag.setAttribute('content', themeCookieValue);
        }
      } else {
        // force default setting in metatag if no cookie exists
        if (themeTagValue !== themeTagDefaultValue) {
          themeTag.setAttribute('content', themeTagDefaultValue);
        }
      }
    }

    // listen for theme selection by user
    const themeSelector = () => {
      if (isAuthenticated) {
        const themeSubtext = themeWrapper.querySelector(
          '.tc_header__dialog__main__nav__item--theme .tc_header__dialog__main__nav__item__subtext',
        );
        const themeInputs = themeWrapper.querySelectorAll(
          'input[name="theme"]',
        );
        for (const themeInput of themeInputs) {
          themeInput.addEventListener('change', (e) => {
            const themeValue = e.target.value;
            const themeLabel = themeWrapper.querySelector(
              `label[for="${e.target.id}"]`,
            ).textContent;
            themeSubtext.textContent = themeLabel;

            // set theme in metatag (CSR) and store theme selection in a cookie (SSR)
            if (themeValue !== themeTagDefaultValue) {
              themeTag.setAttribute('content', themeValue);
              window.tv2.utils.setCookie('tv2Theme', themeValue, '365 days');

              // or remove cookie if value matches the default
            } else {
              themeTag.setAttribute('content', themeTagDefaultValue);
              window.tv2.utils.setCookie('tv2Theme', '', -1);
            }
          });
        }
      }
    };

    // REGION
    const regionSelector = () => {
      const regionWrapper = header.querySelector(
        '.tc_header__dialog__main__nav__item--region',
      );
      const regionSubtext = regionWrapper.querySelector(
        '.tc_header__dialog__main__nav__item__subtext',
      );
      const regionDefaultValue =
        regionWrapper.querySelector('input[checked]').value;
      const regionInputs = regionWrapper.querySelectorAll(
        'input[name="region"]',
      );
      const regionCookieValue = window.tv2.utils.getCookie('tv2Region');

      console.log(regionDefaultValue, regionCookieValue);
      console.log(regionInputs);
      // if the region is already set in a cookie, change the subtext
      if (regionCookieValue) {
        const regionLabel = regionWrapper.querySelector(
          `label[for="region-${regionCookieValue}"]`,
        ).textContent;
        regionSubtext.textContent = regionLabel;
      }

      // mark radio option selected based on region set in cookie
      const regionValue = regionCookieValue || regionDefaultValue;
      regionWrapper.querySelector(
        `input[value="${regionValue}"]`,
      ).checked = true;

      // listen for region selection by user
      for (const regionInput of regionInputs) {
        regionInput.addEventListener('change', (e) => {
          const regionValue = e.target.value;

          // change subtext to match selected region
          const regionLabel = regionWrapper.querySelector(
            `label[for="${e.target.id}"]`,
          ).textContent;
          regionSubtext.textContent = regionLabel;

          // change data attribute to alert regionalDeck about the change
          const form = regionWrapper.querySelector(
            '.tc_header__dialog__main__nav__item__region',
          );
          form.setAttribute('data-region', regionValue);

          // store new region selection in a cookie
          if (regionValue !== regionDefaultValue) {
            window.tv2.utils.setCookie('tv2Region', regionValue, '365 days');
            // or remove cookie if value matches the default
          } else {
            window.tv2.utils.setCookie('tv2Region', '', -1);
          }
        });
      }
    };

    // init watching for menu button clicks
    header.addEventListener('click', buttonClickHandler, false);
  };

  // REEL REFERER
  const reelReferrer = () => {
    const referrerUrl = document.referrer && new URL(document.referrer);
    const referrerFromTv2Dk =
      referrerUrl && referrerUrl.hostname.indexOf('tv2.dk') > -1;

    // if the user came from tv2.dk give them a 'close button' instead of the burger menu
    if (referrerFromTv2Dk) {
      const button = document.querySelector(
        '.tc_header__global__buttons__close',
      );
      if (button && history.length > 1) {
        button.removeAttribute('hidden');
        button.addEventListener('click', () => history.back());
      }
    }
  };

  // BADGE
  const loginButton = header?.querySelector(
    '.tc_header__global__buttons__login',
  );
  if (badgeEnabled && loginButton) {
    const badgeCookie = window.tv2.utils.getCookie('tv2Badge');
    !badgeCookie && loginButton.setAttribute('data-badge', 'true');
  }

  const handleBadge = (action) => {
    if (badgeEnabled && loginButton.hasAttribute('data-badge')) {
      if (action === 'open') {
        // User has seen badge message so hide on future visits
        window.tv2.utils.setCookie('tv2Badge', 'hide', '14 days');
      } else {
        // Hide badge + badge message now
        loginButton.removeAttribute('data-badge');
      }
    }
  };

  if (header && header.dataset.processed !== 'js') {
    headerScrollAnimation();
    dialogs();
    reelReferrer();
    header.setAttribute('data-processed', 'js');
  }
})();
